/**
 * ext-components-pro
 *
 * Adapptio: Set of pro components
 *
 * @package ext-components-pro
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ItemRegistry } from "@adapptio/lib-shared";
import { ITranslationManager } from "@adapptio/lib-core";
import { TGenericViewComponentDefinition } from "@adapptio/lib-components";

import { termsEditor, termsRuntime } from "./terms";

import { ComponentCustomChart } from "./Components/CustomChart/CustomChart";
import { ComponentCustomHtml } from "./Components/CustomHtml/CustomHtml";
import { ComponentCustomComponent } from "./Components/CustomComponent/CustomComponent";
import { ComponentCodeMirror } from "./Components/CodeMirror/CodeMirror";

export function registerComponents(
	registry: ItemRegistry<TGenericViewComponentDefinition>,
	translationManager: ITranslationManager
): void {
	// Logic components
	registry.register(ComponentCustomHtml);

	// Charts components
	registry.register(ComponentCustomChart);

	// From components
	registry.register(ComponentCodeMirror);

	// Other components
	registry.register(ComponentCustomComponent);

	// Register translation terms
	translationManager.registerTerms("editor", termsEditor, "ext-components-pro");
	translationManager.registerTerms("runtime", termsRuntime, "ext-components-pro");
	//translationManager.registerTerms("editor", libTermsEditor, "ext-components-pro#lib");
	//translationManager.registerTerms("runtime", libTermsRuntime, "ext-components-pro#lib");
}
